/**
 * Created by hj on 2017/8/24.
 */
import React from 'react';
import {Button, message} from 'antd';
import {hashHistory} from 'react-router';
import {DmsTab, TableView, FilterBox, AdvanceFormNew} from 'Components';
import {openNotice, config} from 'Utils';
import {writenoffDetailList} from '../../service/financialMgm';

class VerifyingDetailList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['核销明细报表'],
            showHideBtnIndex: 0,
            key: 0,
            filterBoxVisible: false,
            rows: [
                // {
                //   id: 1,
                //   name: '浙江电工张华',
                //   type: '现金',
                //   amount: '500000'
                // },
                // {
                //   id: 2,
                //   name: '浙江电工张华',
                //   type: '欠款',
                //   amount: '250000'
                // }
            ],
            total: 1,
            searchObj: {
                orderType: '',
                startDate: '',
                endDate: '',
                cusName: '',
                writenoffCode: '',
                orderNum: '',
                status: '',
                s: 10,
                p: 1
            },
            selectedRowKeys: [],
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    advanceReset() {
        /* 重置 */
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                orderType: '',
                startDate: '',
                endDate: '',
                cusName: '',
                writenoffCode: '',
                orderNum: '',
                status: '',
                s: 10,
                p: 1
            }
        }, () => {
            this.initData();
        });
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
    };

    advanceSubmit(form) {
        this.initData();
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
    };

    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startDate: value.from ? (value.from + ' 00:00:00') : '',
                    endDate: value.end ? (value.end + ' 23:59:59') : ''
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, () => {
            this.initData();
        });
    }

    goView(url) {
        hashHistory.push(url);
    }

    toEdit(index) {
        /* 编辑 */
        this.goView('card/add/' + this.state.rows[index].id);
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    /*获取列表数据*/
    initData() {
        var obj = this.state.searchObj;
        this.setState({
            loading: true
        });
        writenoffDetailList(obj).then(result => {
            if (result && result.status) {
                // result.data.map((item, index) => {
                //   item.id = index;
                // });
                this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
            }
        })
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    /* 导出 */
    exportExcel() {
        let params = this.state.searchObj;
        window.open(`${config.server}/api/v1/dms/trans/check/exportWritenoffwDetailPo?orderType=${params.orderType}&startDate=${params.startDate}&endDate=${params.endDate}&cusName=${params.cusName}`);
    }

    render() {
        const {opts, key, filterBoxVisible, rows, total, searchObj, showHideBtnIndex, selectedRowKeys, loading} = this.state;
        var self = this;
        const advanceProps = {
            fileds: [
                {
                    name: 'orderType',
                    label: '订单类型',
                    text: '选择订单类型',
                    options: [
                        {value: '', text: '全部'},
                        {value: '1', text: '销售出库'},
                        {value: '2', text: '零售'},
                        {value: '3', text: '销售退货'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.orderType || '全部'
                },
                {
                    name: 'orderTime',//startCreatedDate, endCreatedDate
                    label: '订单日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.createTimeStart || '',
                        end: searchObj.createTimeEnd || ''
                    }
                },
                // {
                //     name: 'verifyTime',//startCreatedDate, endCreatedDate
                //     label: '核销日期',
                //     options: [
                //         { text: '开始时间' },
                //         { text: '结束时间' },
                //     ],
                //     type: 'dateComp',
                //     defaultValue: {
                //         from: searchObj.createTimeStart || '',
                //         end: searchObj.createTimeEnd || ''
                //     }
                // },
                {
                    name: 'cusName',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'default',
                    defaultValue: searchObj.cusName
                }, {
                    name: 'writenoffCode',
                    label: '收款编号',
                    text: '输入收款编号',
                    type: 'default',
                    defaultValue: searchObj.writenoffCode
                },
                {
                    name: 'orderNum',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.orderNum
                },
                {
                    name: 'status',
                    label: '状态',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: '已核销', text: '已核销'},
                        {value: '部分核销', text: '部分核销'},
                        {value: '未核销', text: '未核销'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.status || '全部'
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'orderId',
            pageParam: {
                total,
                current: searchObj.p, //当前页码
                pageSize: searchObj.s,  //当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '序号',
                    dataIndex: 'num',
                    render: (text, record, index) => index + 1 + ((searchObj.p - 1) * 10)
                    // render: (text, record, index) => {
                    //   // let _index = (this.state.searchObj.p - 1) * this.state.searchObj.s + index + 1;
                    //   return index + 1;
                    // }
                },
                {
                    title: '订单号',
                    dataIndex: 'orderNum'
                },
                {
                    title: '客户名称',
                    dataIndex: 'cusName'
                },
                {
                    title: '订单类型',
                    dataIndex: 'orderType',
                    render: text => {
                        if (text == 1) {
                            return '销售出库'
                        }
                        if (text == 2) {
                            return '零售出库'
                        }
                        if (text == 3) {
                            return '销售退货'
                        }
                    }
                },
                // {
                //   title: '核销日期',
                //   dataIndex: 'date'
                // },
                // {
                //   title: '订单时间',
                //   dataIndex: 'orderTime'
                // },
                {
                    title: '订单金额',
                    dataIndex: 'orderCount',
                    render: (text, record, index) => {
                        return record.orderCount.toFixed(2);
                    }
                },
                {
                    title: '已核销金额',
                    dataIndex: 'writenoffCount',
                    render: (text, record, index) => {
                        return record.writenoffCount.toFixed(2);
                    }
                },
                {
                    title: '未核销金额',
                    dataIndex: 'unWritenoffCount',
                    render: (text, record, index) => {
                        return record.unWritenoffCount.toFixed(2);
                    }
                },
                {
                    title: '核销编号',
                    dataIndex: 'writenoffCodeList',
                    render: text => {
                        if (text && text != []) {
                            var show = ''
                            for (var i = 0; i < text.length; i++) {
                                show = show + text[i] + '; ';
                            }
                            return show
                        }
                    }
                },
                {
                    title: '核销状态',
                    dataIndex: 'status'
                },
            ],
            rows,
            rowSelection: {
                selectedRowKeys, onChange: (e) => {
                    this.setState({selectedRowKeys: e})
                }
            }
        };
        return <div className="dms-body">
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.exportExcel.bind(this)} style={{position: 'absolute', bottom: 8, right: 0}}
                            icon="export">导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}
;
export default VerifyingDetailList;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/verifyingDetailList.js